import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ListService } from '@fry/lib/list';
import { BookingItemsSearch } from '@fry/booking/lib/booking-items';


@Component({
    selector: 'eas-booking-items',
    templateUrl: './booking-items.component.html',
    providers: [
        ListService,
        BookingItemsSearch,
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BookingItemsComponent {

  constructor(
  ) { }

}
